(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hhs-availability"] && !Shopify.designMode) return;
  try {
    if (!window.eterikHhsNotifyTrackingBound) {
    window.eterikHhsNotifyTrackingBound = true;
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.hhs-availability__form');
      if (!form) return;

      const container = form.closest('[data-hhs-availability-hook]');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hhs_availability_request',
        product_handle: container?.dataset.productHandle || '',
        country_code: container?.dataset.countryCode || '',
        language_code: container?.dataset.languageCode || '',
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
